<div class="am-flex-align gap-xs">
  <div class="am-flex-align">
    <span class="am-flex-center hover-active-blue p-xxs font-icon icon-bars mobile-toggler" toggleSidebar></span>
    @if (backCallback) { <span class="am-flex-center hover-active-blue p-xxs font-icon icon-arrow-left" (click)="backCallbackHandler()"></span> }
  </div>
  <div class="am-flex hover-active width-90" (click)="openHomePage()">
    <img class="width-max-full" src="assets/images/tempton-logo-blue.png" alt="homepage" />
  </div>
</div>

<div class="am-flex-align gap-xs">
  <div class="am-flex-center height-36 b-grey overflow bg-white hover-active font-s" (click)="opePillPicker()">
    <span class="font-s br-grey am-flex-align height-full pr-xs pl-xs">
      @if      (actives.length == 1) { {{ actives[0]     }}            }
      @else if (actives.length  > 1) { {{ actives.length }} ausgewählt }
      @else                          { Alle }
    </span>
    <span class="pl-xs pr-xs am-flex-center font-icon color-blue icon-source_environment"></span>
  </div>
  <div class="am-flex-column gap-xxxs p-xs b-grey bg-white" (click)="openApplicationSwitcher()">
    <div class="am-flex-align gap-xxxs">
      <span class="width-xs height-xs bg-asc-tl"></span>
      <span class="width-xs height-xs bg-asc-tr"></span>
    </div>
    <div class="am-flex-align gap-xxxs">
      <span class="width-xs height-xs bg-asc-bl"></span>
      <span class="width-xs height-xs bg-asc-br"></span>
    </div>
  </div>
</div>
